import { gsap } from "gsap";

export default class EventHeader {
	constructor(elm) {
        this.elm = elm;

        this.front = this.elm.querySelectorAll('[data-front]');
        this.frontImages = [];
        this.front.forEach(front => {
            this.frontImages.push(front.querySelector('img'));
        });
        this.middle = this.elm.querySelectorAll('[data-middle]');
        this.middleImages = [];
        this.middle.forEach(middle => {
            this.middleImages.push(middle.querySelector('img'));
        });

        if(this.frontImages.length>0) {
            this.loopAnimation();
        }

	}

    loopAnimation() {

        const mm = gsap.matchMedia();

		mm.add({
				isMobile: "(max-width: 991px)",
				isDesktop: "(min-width: 992px)",
				reduceMotion: "(prefers-reduced-motion: reduce)",
			}, (context) => {
                let { isMobile, isDesktop, reduceMotion } = context.conditions

                if(!reduceMotion) {
                    const loop = gsap.timeline({
                        repeat: -1
                    });
                loop.to(this.frontImages, {
                    x: '5%',
                    y: '-3%',
                    scale: 1.1,
                    duration: 8,
                    ease: 'expo.inOut',
                });

                loop.to(this.middleImages, {
                    x: '-5%',
                    y: '3%',
                    scale: 1.1,
                    duration: 10,
                    ease: 'expo.inOut',
                }, 2);

                loop.to(this.frontImages, {
                    x: '-5%',
                    y: '3%',
                    scale: 1.1,
                    duration: 8,
                    ease: 'expo.inOut',
                });

                loop.to(this.middleImages, {
                    x: '5%',
                    y: '-3%',
                    scale: 1.1,
                    duration: 7,
                    ease: 'expo.inOut',
                });

                loop.to(this.frontImages, {
                    x: '0',
                    y: '0',
                    scale: 1,
                    duration: 7,
                    ease: 'power2.out'
                });

                loop.to(this.middleImages, {
                    x: '0',
                    y: '0',
                    scale: 1,
                    duration: 9,
                    ease: 'expo.inOut',
                });
            }
        });
    }

}
